// please remember to also update values in `workers-site/writeOpenGraphTags.js`

const mockData = {
  capture: {
    title: 'just passing by 😂',
    creator: {
      username: 'maneet',
      givenName: 'Maneet',
      familyName: 'Khaira',
      avatarUrl: 'https://res.cloudinary.com/backbone-labs/image/upload/v1593308376/avatars/9Q56VoAdoY/4e01c78c-a5fd-4378-bcf9-e6990ec94672.png',
    },
    game: {
      name: 'Call of Duty: Mobile',
    },
    createdAt: "2020-06-29T20:01:13.000Z",
    shareUrl: 'https://backbone.com/highlights/ah981DbK3/just-passing-by',
    webResourceUrl: 'https://storage.googleapis.com/backbone-cloud-storage/2-triple-feed-cropped.mp4',
    dashResourceUrl: 'https://storage.googleapis.com/backbone-cloud-storage/2-triple-feed-cropped.mp4',
    hlsResourceUrl: 'https://storage.googleapis.com/backbone-cloud-storage/2-triple-feed-cropped.mp4',
    thumbnailUrl: 'https://storage.googleapis.com/backbone-cloud-storage/3-triple-feed-cropped-frame.jpg',
    highlightsSamples: [
      0,
      0.08333333333333333,
      0.043333333333333335,
      0.12,
      0.02,
      0.07,
      0.94,
      0.10333333333333333,
      0.07666666666666666,
      0.30666666666666664,
      0.07333333333333333,
      0.016666666666666666,
      0.11666666666666667,
      0.016666666666666666,
      0.10666666666666667,
      0.03,
      0.5833333333333334,
      0.04,
      0.9466666666666667,
      0.016666666666666666,
      0.03666666666666667,
      0.10333333333333333,
      0.06,
      0
    ],
  }
};

export default mockData;
